import React, { useState, useRef, useEffect } from 'react';
import './body.css';
import { useTranslation } from "react-i18next";
import avatar1 from "../../../assets/img/seleccion-avatar-1.png";
import avatar2 from "../../../assets/img/seleccion-avatar-2.png";
import avatar3 from "../../../assets/img/seleccion-avatar-3.png";
import avatar4 from "../../../assets/img/seleccion-avatar-4.png";
import arrowDownIcon from "../../../assets/img/flecha-scroll.svg";
import rbs_img from "../../../assets/img/rbs_jun_2020_6.png";
import star_yellow from "../../../assets/img/estrella-amarilla.png";
import star_gray from "../../../assets/img/estrella-gris.png";
import rbs_medio from "../../../assets/img/rbs_medio_1.png";
import btn_comp from "../../../assets/img/Botoon-compartir-dim1.png";

import iconoCompartir from "../../../assets/imgs/detalle_blog/share-white.svg";
import iconoX from "../../../assets/imgs/detalle_blog/logo-x.svg";
import iconoFacebook from "../../../assets/imgs/detalle_blog/Asset_Facebook-normal.svg";
import iconoLinkedIn from "../../../assets/imgs/detalle_blog/LinkedIn.svg";
import iconoMail from "../../../assets/imgs/detalle_blog/Asset_Mail-Normalblanco.svg";
import iconoCopiar from "../../../assets/imgs/detalle_blog/Link.svg";

const Bodyend = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [selectedAvatar, setSelectedAvatar] = useState(null);
    const [currentSlide, setCurrentSlide] = useState(1);
    const [progressPercentage, setProgressPercentage] = useState(0);
    const [apiResponse, setApiResponse] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);
    const [loading, setLoading] = useState(false);
    const [variable, setVariable] = useState(-4);
    const [isGifPlaying, setIsGifPlaying] = useState(false);
    const [isFlipped, setIsFlipped] = useState(false);
    const [isClick, setIsClick] = useState(false);
    const [title, setTitle] = useState("¡Comencemos!");
    const [isClick2, setIsClick2] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [isClick3, setIsClick3] = useState(false);

    const [position, setPosition] = useState({ x: 80, y: 25 }); // Posición inicial en porcentaje
    const [dragging, setDragging] = useState(false);
    const [offset, setOffset] = useState({ x: 0, y: 0 }); // Para corregir el desplazamiento
    const cardRef = useRef(null); // Referencia al contenedor
    const avatarRef = useRef(null); // Referencia al avatar arrastrable
    const targetRef = useRef(null); // Referencia al objetivo (rbs_medio)

    // Estados para almacenar las respuestas de cada diapositiva
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [slide2Q1, setSlide2Q1] = useState("");
    const [slide2Q2, setSlide2Q2] = useState("");
    const [slide3Q1, setSlide3Q1] = useState("");
    const [slide3Q2, setSlide3Q2] = useState("");
    const [slide5Q1, setSlide5Q1] = useState("");

    const avatars = [
        { static: "https://ricardosalinas.com/content/assets/img/avatars/avatar1-base.png", animated: "https://ricardosalinas.com/content/assets/img/avatars/avatar1-seleccion.gif" },
        { static: "https://ricardosalinas.com/content/assets/img/avatars/avatar2-base.png", animated: "https://ricardosalinas.com/content/assets/img/avatars/avatar2-seleccion.gif" },
        { static: "https://ricardosalinas.com/content/assets/img/avatars/avatar3-base.png", animated: "https://ricardosalinas.com/content/assets/img/avatars/avatar3-seleccion.gif" },
        { static: "https://ricardosalinas.com/content/assets/img/avatars/avatar4-base.png", animated: "https://ricardosalinas.com/content/assets/img/avatars/avatar4-seleccion.gif" }
    ];

    const handleEmailChange = (event) => {
        const { value } = event.target;
        setEmail(value);

        // Validar el formato del correo electrónico
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setIsValidEmail(emailRegex.test(value));
    };

    const handleX = () => {
        window.open(
            `https://twitter.com/intent/tweet?url=${encodeURIComponent(
                "https://www.ricardosalinas.com/5bfd0e31-af85-4bb1-91c8-997d81fec963"
            )}&text=${encodeURIComponent("Contesté el Quizz de Ricardo Salinas  y mi pensamiento es un " + apiResponse.data.porcentaje_de_rs + "% parecido al suyo. \n¡Descubre cuál es el tuyo!")}`,
            "_blank"
        );
    };

    const handleFacebook = () => {
        window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent("https://www.ricardosalinas.com/5bfd0e31-af85-4bb1-91c8-997d81fec963")}`,
            "_blank"
        );
    };

    const handleLinkedIn = (e) => {
        window.open(
            `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
                "https://www.ricardosalinas.com/5bfd0e31-af85-4bb1-91c8-997d81fec963"
            )}&title=${encodeURIComponent("Quote Quizz")}&summary=${encodeURIComponent("Contesté el Quizz de Ricardo Salinas  y mi pensamiento es un " + apiResponse.data.porcentaje_de_rs + "% parecido al suyo. \n¡Descubre cuál es el tuyo!")}`,
            "_blank"
        );
    };

    const handleMail = () => {
        const subject = "Quote Quizz";
        const body = `Hola,
        
        Contesté el Quizz de Ricardo Salinas  y mi pensamiento es un `+ apiResponse.data.porcentaje_de_rs + `% parecido al suyo. \n
        ¡Descubre cuál es el tuyo!
        \n\n
        https://www.ricardosalinas.com/5bfd0e31-af85-4bb1-91c8-997d81fec963
        
        `;

        window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    };

    const handleCopiarURL = () => {
        navigator.clipboard.writeText("https://www.ricardosalinas.com/5bfd0e31-af85-4bb1-91c8-997d81fec963").then(() => {
            alert('¡Enlace copiado al portapapeles!');
        }).catch((error) => {
            console.error('Error al copiar al portapapeles:', error);
        });
    };


    const handleAvatarClick = (avatar, index) => {
        if (index == 0) {
            setSelectedAvatar("https://ricardosalinas.com/content/assets/img/avatars/avatar1-");
        } else if (index == 1) {
            setSelectedAvatar("https://ricardosalinas.com/content/assets/img/avatars/avatar2-");
        } else if (index == 2) {
            setSelectedAvatar("https://ricardosalinas.com/content/assets/img/avatars/avatar3-");
        } else if (index == 3) {
            setSelectedAvatar("https://ricardosalinas.com/content/assets/img/avatars/avatar4-");
        }

        setActiveIndex(index);
    };

    useEffect(() => {
        // Función para verificar si es móvil o escritorio
        const checkDevice = () => {
            // Cambia a 4 si el ancho de la ventana es menor a 768px (móvil), y -4 si es escritorio
            if (window.innerWidth > 1000) {
                setVariable(-5);
            }
            else if (window.innerWidth > 600) {
                setVariable(-7);
            }
            else if (window.innerWidth > 400) {
                setVariable(-10);
            }
            else {
                setVariable(-12);
            }

        };

        // Ejecutar la verificación al cargar el componente
        checkDevice();

        // Escuchar el evento de redimensionamiento para ajustar la variable si la ventana cambia de tamaño
        window.addEventListener('resize', checkDevice);

        // Eliminar el event listener al desmontar el componente
        return () => {
            window.removeEventListener('resize', checkDevice);
        };
    }, []); // Solo se ejecuta al montar/desmontar el componente

    const handleStart = () => {
        if (name && email && selectedAvatar) {
            if (isValidEmail) {
                setCurrentSlide(2);  // Avanza al siguiente slide si todo está completo
                setIsClick2(true);

                setTimeout(() => {
                    setIsClick2(false);
                }, 600);
            } else {
                alert("El formato del correo es incorrecto");
                return;
            }

        }
        else {
            alert("Por favor ingresa la información necesaria antes de continuar.");
        }
    };

    // Validación para avanzar entre diapositivas
    const handleNextSlide = (slideNumber) => {
        if (currentSlide === 2) {
            if (!slide2Q1 || !slide2Q2) {
                alert("Por favor responde todas las preguntas antes de continuar.");
                return;
            }
        } else if (currentSlide === 3) {
            if (!slide3Q1 || !slide3Q2) {
                alert("Por favor responde todas las preguntas antes de continuar.");
                return;
            }
        } else if (currentSlide === 5) {
            if (!slide5Q1) {
                alert("Por favor responde la pregunta antes de continuar.");
                return;
            }
        }

        // Activar animación de flip
        setIsFlipped(!isFlipped);
        setIsClick(true);

        setTimeout(() => {
            setIsClick(false);
        }, 500);  // Tiempo que coincide con la animación en CSS

        // Cambiar la diapositiva después de un pequeño retraso para que coincida con la animación
        setTimeout(() => {
            setCurrentSlide(slideNumber);
            setIsClick2(true);

            setTimeout(() => {
                setIsClick2(false);
            }, 600);

        }, 500);  // Tiempo que coincide con la animación en CSS
    };

    const extractVariable = (link) => {
        if (link.includes("GUID=")) {
            return "https://www.ricardosalinas.com/blog/images/posters/" + link.split("GUID=")[1].split("&")[0] + ".jpg";
        } else if (link.includes("/blog/")) {
            return "https://www.ricardosalinas.com/blog/images/posters/" + link.split("/blog/")[1].split("&")[0] + ".jpg";
        } else if (link.includes("watch?v=")) {
            return "https://www.ricardosalinas.com/blog/images/posters/" + link.split("watch?v=")[1].split("&")[0] + ".jpg";
        } else if (link.includes("shorts/")) {
            return "https://www.ricardosalinas.com/blog/images/posters/" + link.split("shorts/")[1].split("&")[0] + ".jpg";
        } else {
            return "https://www.ricardosalinas.com/blog/images/imgvideo.jpg";
        }
    };

    const defineTitle = (porcentaje) => {
        if (porcentaje > 80) {
            return "¡Felicidades";
        } else if (porcentaje > 60) {
            return "¡Mantén tu visión en evolución";
        } else if (porcentaje > 40) {
            return "¡El esfuerzo es todo ";
        } else {
            return "¡El esfuerzo es todo ";
        }
    };

    const handleFinalSubmit = async () => {
        if (!slide5Q1) {
            alert("Por favor responde la pregunta antes de continuar.");
            return;
        }

        setCurrentSlide(6);
        setIsLoading(true)
        setLoading(true); // Iniciar el estado de carga

        const requestBody = {
            "A01": slide2Q1 || "",
            "A02": slide2Q2 || "",
            "A03": slide3Q1 || "",
            "A04": slide3Q2 || "",
            "A05": slide5Q1 || ""
        };

        try {

            const response = await fetch('https://dinamicars.algoverse.ai/model/v1/chatbot', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa('usuario2:pass1')
                },
                body: JSON.stringify(requestBody)
            });

            if (response.ok) {
                const data = await response.json();
                setApiResponse(data);

                // Preparar el cuerpo para la segunda API
                const secondApiBody = {
                    preguntas: "PRUEBA 6",
                    respuestas: Object.values(requestBody).join("||"),
                    tipo: "tipo1",
                    porcentaje: data.data.porcentaje_de_rs,
                    nombre: name,
                    correo: email
                };

                // Segunda API: Guardar datos
                const secondResponse = await fetch('https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/quiz/new', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(secondApiBody)
                });

                if (!secondResponse.ok) {
                    console.error('Error en la respuesta de la segunda API:', secondResponse.statusText);
                }
                else {

                }
            } else {
                console.error('Error en la respuesta de la primera API:', response.statusText);
            }

            //setApiResponse(apiResponse);
            //setCurrentSlide(6); 
        } catch (error) {
            console.error("Error fetching API data:", error);
        }
        finally {
            setLoading(false); // Detener el estado de carga
            setTimeout(() => {
                setIsLoading(false);
            }, 500);  // Tiempo que coincide con la animación en CSS
        }
    };

    // Cálculo del progreso según la diapositiva actual
    useEffect(() => {
        // Contar cuántas variables no son cadenas vacías
        const filledQuestions = [
            slide2Q1,
            slide2Q2,
            slide3Q1,
            slide3Q2,
            slide5Q1
        ].filter(question => question !== "").length;

        // Actualizar el valor de progressPercentage
        setProgressPercentage(filledQuestions);

        // Reproducir el GIF durante unos segundos cuando el progreso cambie
        if (filledQuestions > 0) {
            setIsGifPlaying(true);  // Activar el GIF

            // Detener el GIF y volver a la imagen base después de 2 segundos
            const timer = setTimeout(() => {
                setIsGifPlaying(false);  // Volver a la imagen estática
            }, 3000);  // Cambia el tiempo según lo que necesites (2000 ms = 2 segundos)

            return () => clearTimeout(timer);  // Limpiar el temporizador cuando el componente se desmonte
        }
    }, [slide2Q1, slide2Q2, slide3Q1, slide3Q2, slide5Q1]);

    useEffect(() => {
        if (currentSlide == 3) {
            setTitle("¡Excelente avance!");
        } else if (currentSlide == 4) {
            setTitle("¡Concéntrate, ya casi terminas!");
        } else if (currentSlide == 5) {
            setTitle("¡Estás a un paso del resultado!");
        }

    }, [currentSlide]);

    const handleMouseDown = (e) => {
        e.preventDefault();

        const startX = e.clientX || e.touches[0].clientX;
        const startY = e.clientY || e.touches[0].clientY;

        const avatarRect = avatarRef.current.getBoundingClientRect();
        const offsetX = startX - avatarRect.left; // Diferencia entre el mouse y la esquina superior izquierda del avatar
        const offsetY = startY - avatarRect.top;

        setOffset({ x: offsetX, y: offsetY });
        setDragging(true);
    };

    const handleMouseMove = (moveEvent) => {
        if (!dragging) return;

        const currentX = moveEvent.clientX || moveEvent.touches[0].clientX;
        const currentY = moveEvent.clientY || moveEvent.touches[0].clientY;

        const cardRect = cardRef.current.getBoundingClientRect();
        const avatarWidth = avatarRef.current.offsetWidth;
        const avatarHeight = avatarRef.current.offsetHeight;

        // Calcular la nueva posición del avatar dentro del contenedor en el eje X
        let newX = ((currentX - cardRect.left - offset.x) / cardRect.width) * 100;

        // Calcular la nueva posición del avatar en el eje Y (invirtiendo el eje)
        let newY = ((cardRect.bottom - currentY - offset.y) / cardRect.height) * 100;

        // Limitar la posición del avatar dentro de los bordes del contenedor
        newX = Math.max(0, Math.min(newX, 100 - (avatarWidth / cardRect.width) * 100));
        newY = Math.max(0, Math.min(newY, 100 - (avatarHeight / cardRect.height) * 100));

        setPosition({ x: newX, y: newY });
    };

    const handleMouseUp = () => {
        setDragging(false);

        // Comprobar si el avatar se ha soltado cerca de la otra imagen
        const avatarRect = avatarRef.current.getBoundingClientRect();
        const targetRect = targetRef.current.getBoundingClientRect();

        const isNearTarget =
            avatarRect.right >= targetRect.left &&
            avatarRect.left <= targetRect.right &&
            avatarRect.bottom >= targetRect.top &&
            avatarRect.top <= targetRect.bottom;

        if (isNearTarget) {
            console.log('Avatar colocado cerca de Ricardo Salinas');

            setIsClick3(true);

            setTimeout(() => {
                setIsClick3(false);
                handleNextSlide(currentSlide + 1);
            }, 500);  // Tiempo que coincide con la animación en CSS
        }
    };


    return (
        <div className='act-rbs-alg'>
            <div className={`anim-trans-stars ${isLoading ? 'is-view' : ''}`} >
                <img src='https://ricardosalinas.com/content/assets/img/avatars/transicioon-estrellas-2.gif'></img>
            </div>
            {/* Barra de progreso */}
            {currentSlide > 1 && currentSlide < 6 && (
                <div className="progress-bar-container">
                    <h2 className={`${isClick2 ? 'bailando' : ''}`}>{title}</h2>
                    <div className='div-img-trans-f' style={{ marginLeft: `${variable + (progressPercentage * 20)}%` }}>


                        {selectedAvatar && (
                            <img
                                src={isGifPlaying ? selectedAvatar + "progreso.gif" : selectedAvatar + "base.png"}
                                alt="Selected Avatar"
                                className="avatar-icon"
                            />
                        )}
                        <img className={`img-trans-fimg ${isGifPlaying ? 'is-view' : ''}`} src="https://ricardosalinas.com/content/assets/img/avatars/estrellas-linea-progreso.gif"></img>
                    </div>
                    <div className="progress-bar">
                        <div className="progress" style={{ width: `${progressPercentage * 20}%` }}></div>
                    </div>
                </div>)}

            {/* Slide 1: Selección de avatar y entrada de datos */}

            {currentSlide === 1 && (
                <>
                    <div className="slide1-background">
                        <div className="slide1">
                            <h2>Elige tu avatar</h2>
                            <div className="avatars">
                                {avatars.map((avatar, index) => (
                                    <img
                                        key={index}
                                        src={activeIndex === index ? avatar.animated : avatar.static}  // Mostrar GIF animado solo si es el activo
                                        onClick={() => handleAvatarClick(avatar.animated, index)}  // Asignar el GIF animado como seleccionado
                                        onMouseEnter={(e) => e.currentTarget.src = avatar.animated} // Al pasar el mouse, mostrar el GIF animado
                                        onMouseLeave={(e) => {
                                            if (activeIndex !== index) {
                                                e.currentTarget.src = avatar.static;  // Volver a la imagen estática si no está seleccionado
                                            }
                                        }}
                                        className={activeIndex === null ? "" : (activeIndex === index ? "active-avatar" : "not-active-avatar")}
                                        alt={`Avatar ${index + 1}`}
                                    />
                                ))}
                            </div>
                            <div className="preg-avatars">
                                <p>Escribe tu nombre</p>
                                <input type="text" placeholder="" onChange={(e) => setName(e.target.value)} />
                                <p className='preg2'>Escribe tu correo electrónico</p>
                                <input type="email" placeholder="" onChange={handleEmailChange} />
                            </div>
                        </div>
                        <button className='btn-slide-1' onClick={handleStart}>¡Inicia el reto!</button>
                    </div>
                </>
            )}

            {currentSlide > 1 && currentSlide < 6 && (
                <>
                    <div className={`card-algo ${isFlipped ? 'is-flipped' : ''}`}>
                        <div className={`card-algo-front ${currentSlide == 4 ? 'orange-back' : ''}`} >
                            {currentSlide === 2 && (
                                <div className="slide2">
                                    <div className="question">
                                        <p>¿Qué piensas sobre <strong>la libertad</strong>?</p>
                                        <textarea type="text" value={slide2Q1} onChange={(e) => setSlide2Q1(e.target.value)} />
                                    </div>
                                    <div className="question question2">
                                        <p>¿Cuál es la importancia de <strong>la libertad para el progreso</strong>?</p>
                                        <textarea type="text" value={slide2Q2} onChange={(e) => setSlide2Q2(e.target.value)} />
                                    </div>
                                </div>
                            )}
                            {currentSlide === 4 && (
                                <div className="slide4">

                                    <div
                                        className="card-slide4-img"
                                        ref={cardRef}
                                        onMouseMove={handleMouseMove}
                                        onMouseUp={handleMouseUp}
                                        onTouchMove={handleMouseMove}
                                        onTouchEnd={handleMouseUp}
                                    >
                                        <img
                                            ref={targetRef}
                                            src={rbs_medio}
                                            className="rbs-img-rbs"
                                            alt="Ricardo Salinas"
                                        />
                                        <img className={`btn-next-act-anim3 ${isClick3 ? 'is-view' : ''}`} src="https://ricardosalinas.com/content/assets/img/avatars/estrellas-boton-siguiente.gif" />
                                        <img
                                            ref={avatarRef}
                                            src={selectedAvatar + 'base.png'}
                                            className="rbs-img-s"
                                            alt="Avatar"
                                            style={{ left: `${position.x}%`, bottom: `${position.y}%` }} // Se usa 'bottom' para la posición Y
                                            onMouseDown={handleMouseDown}
                                            onTouchStart={handleMouseDown} // Para móviles
                                        />
                                    </div>
                                    <p className='txt-act-an'><strong>Mueve</strong> tu avatar hacia<br className='nly-mov'></br> Ricardo Salinas</p>
                                </div>
                            )}
                        </div>
                        <div className='card-algo-back'>
                            {currentSlide === 3 && (
                                <div className="slide3">
                                    <div className="question">
                                        <p>Desde la perspectiva de Ricardo, ¿por qué es más relevante enfocarse en <strong>acabar con la pobreza</strong> en lugar de eliminar la desigualdad?</p>
                                        <textarea type="text" value={slide3Q1} onChange={(e) => setSlide3Q1(e.target.value)} />
                                    </div>
                                    <div className="question">
                                        <p>¿Cuál es <strong>la forma más eficiente</strong> de acabar con la pobreza?</p>
                                        <textarea type="text" value={slide3Q2} onChange={(e) => setSlide3Q2(e.target.value)} />
                                    </div>

                                </div>
                            )}
                            {currentSlide === 5 && (
                                <>
                                    <div className="slide5">
                                        <div className="question">
                                            <p>¿Qué <strong>pilar(*) de la prosperidad incluyente</strong> es más importante para ti y por qué?</p>
                                            <textarea type="text" value={slide5Q1} onChange={(e) => setSlide5Q1(e.target.value)} />
                                            <p><strong>* Los pilares son:<br></br>
                                                &nbsp;&nbsp;&nbsp;-Valor económico<br></br>
                                                &nbsp;&nbsp;&nbsp;-Valor social<br></br>
                                                &nbsp;&nbsp;&nbsp;-Valor ambiental</strong></p>
                                        </div>
                                    </div>

                                </>
                            )}
                        </div>
                    </div>
                    {currentSlide < 4 && (
                        <>
                            <button className='btn-next-act' onClick={() => handleNextSlide(currentSlide + 1)}><img src={arrowDownIcon} /></button>
                            <img className={`btn-next-act-anim ${isClick ? 'is-view' : ''}`} src="https://ricardosalinas.com/content/assets/img/avatars/estrellas-boton-siguiente.gif" />
                            <p className='btn-next-act-text' onClick={() => handleNextSlide(currentSlide + 1)}>Siguiente</p>
                        </>
                    )}
                    {currentSlide === 5 && (
                        <>
                            <button className='btn-next-act' onClick={handleFinalSubmit}><img src={arrowDownIcon} /></button>
                            <p className='btn-next-act-text' onClick={handleFinalSubmit}>Siguiente</p>
                        </>
                    )}
                </>
            )}
            {/* <img src="https://ricardosalinas.com/content/assets/img/avatars/Transicion-estrellas.gif"></img>*/}

            {/* Slide 6: Resultado de la API */}
            {currentSlide === 6 && (
                loading ? (
                    <>
                        <div className='act-loading'>
                            {/* <p>Cargando...</p>*/}
                            <img src='https://www.ricardosalinas.com/blog/images/Loading_icon.gif' alt="Loading icon" />
                        </div>
                    </>
                ) : (
                    apiResponse && (
                        <div className="api-response">
                            <div className='div-lab-tit'>
                                <h2>{defineTitle(apiResponse.data.etiqueta)} {name}!</h2>
                            </div>
                            <div className='div-result-porcent-div'>
                                <div className='div-result-porcent'>
                                    <div className='card-rest-porcent'>
                                        <div className='card-rest-porcent-img'>
                                            <img src={rbs_img}></img>
                                        </div>
                                        <div className='card-rest-porcent-txt'>
                                            <div className='card-rest-porcent-stars'>
                                                {/* Renderizar las estrellas amarillas */}
                                                <div className='stars-img'>
                                                    {[...Array(Math.floor(apiResponse.data.porcentaje_de_rs / 20))].map((_, index) => (
                                                        <img key={index} src={star_yellow} alt="Estrella amarilla" />
                                                    ))}

                                                    {/* Renderizar las estrellas grises */}
                                                    {[...Array(5 - (Math.floor(apiResponse.data.porcentaje_de_rs / 20)))].map((_, index) => (
                                                        <img key={index} src={star_gray} alt="Estrella gris" />
                                                    ))}
                                                </div>
                                                <div className='stars-bar'>
                                                    <div className='stars-bar-porcent' style={{ width: `${apiResponse.data.porcentaje_de_rs}%` }}>

                                                    </div>
                                                </div>
                                            </div>
                                            <p>¡Eres <strong><span className='txt-ama'>{Math.ceil(parseFloat(apiResponse.data.porcentaje_de_rs))}%</span></strong> compatible <br></br>con Ricardo Salinas!</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='div-result-avatar'>
                                    {selectedAvatar && <img src={
                                        selectedAvatar +
                                        (Math.ceil(parseFloat(apiResponse.data.porcentaje_de_rs)) > 50
                                            ? "resultado12.gif"
                                            : "resultado34.gif")
                                    } alt="Selected Avatar" className="avatar-icon-result" />}
                                    <div className='div-result-avatar-card'>
                                        <h4>{apiResponse.data.etiqueta.split('!')[0]}!</h4>
                                        <p>{apiResponse.data.etiqueta.split('!')[1]}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="barra_texto_Desk_div">
                                <div className="barra_texto_Desk">
                                    <button>
                                        <div className="container-imagen">
                                            <img src={btn_comp} alt="icono compartir" />
                                        </div>
                                        <ul className="socials" onClick={(e) => e.stopPropagation()}>
                                            <li>
                                                <img src={iconoX} alt="icono x" onClick={handleX} />
                                            </li>
                                            <li>
                                                <img
                                                    src={iconoFacebook}
                                                    alt="icono facebook"
                                                    onClick={handleFacebook}
                                                />
                                            </li>
                                            <li>
                                                <img
                                                    src={iconoLinkedIn}
                                                    alt="icono linkedIn"
                                                    onClick={handleLinkedIn}
                                                />
                                            </li>
                                            <li>
                                                <img src={iconoMail} alt="icono mail" onClick={handleMail} />
                                            </li>
                                            <li>
                                                <img
                                                    src={iconoCopiar}
                                                    alt="icono copiar url"
                                                    onClick={handleCopiarURL}
                                                />
                                            </li>
                                        </ul>
                                    </button>
                                </div>
                            </div>
                            <div className='div-result'>
                                <div className='div-recomnd'>
                                    <h4>¡Sigue inspirándote!</h4>
                                    <div className='div-recomnd-back'>
                                        <h3>¡Tenemos 3 recomendaciones para ti!</h3>
                                        <div className='div-recomnd-list'>
                                            {apiResponse.data.links.map((linkPair, index) => {
                                                const [title, link] = linkPair;
                                                const variable = extractVariable(link);
                                                const cardClassName = index === 2 ? 'actv-card-large' : 'actv-card';
                                                return (
                                                    <div className={cardClassName} key={index}>
                                                        <a target='_blank' href={link}><img src={variable} className='actv-card-poster' alt={title} /></a>
                                                        <p><a className='actv-card-link' target='_blank' href={link}>{title}</a></p>
                                                    </div>
                                                );
                                            })}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                )
            )}
        </div>
    );
};

export default Bodyend;